import { create } from 'zustand';

interface SidebarState {
  isCollapsed: boolean;
  isMobileOpen: boolean;
  toggle: () => void;
  expand: () => void;
  collapse: () => void;
  openMobile: () => void;
  closeMobile: () => void;
}

function getStoredCollapsed(): boolean {
  return localStorage.getItem('isp_sidebar_collapsed') === 'true';
}

export const useSidebarStore = create<SidebarState>((set) => ({
  isCollapsed: getStoredCollapsed(),
  isMobileOpen: false,

  toggle: () =>
    set((state) => {
      const next = !state.isCollapsed;
      localStorage.setItem('isp_sidebar_collapsed', String(next));
      return { isCollapsed: next };
    }),

  expand: () => {
    localStorage.setItem('isp_sidebar_collapsed', 'false');
    set({ isCollapsed: false });
  },

  collapse: () => {
    localStorage.setItem('isp_sidebar_collapsed', 'true');
    set({ isCollapsed: true });
  },

  openMobile: () => set({ isMobileOpen: true }),
  closeMobile: () => set({ isMobileOpen: false }),
}));
